import React, { useState, useEffect } from "react";
import CloseImg from "../../assets/images/close.png";
import { useDispatch, useSelector } from "react-redux";
import {
  AddOrUpdateCollectionThunk,
  getAllCollectionsByAppUserIdlAndCompanyDivId,
} from "COLLECTION/collectionApi";
import { Link, useNavigate } from "react-router-dom";
import useAdminHelperFunction from "../../CustomHooks/useAdminHelperFunction";

function ColletionsSuccessModal({ isOpen, onClose, collectedItem }) {
  const [isAddAnotherCollection, setIsAddAnotherCollection] = useState(false);
  const navigate = useNavigate();
  const onAddAnotherCollection = () => {
    setIsAddAnotherCollection(true);
  };
  const collectionState = useSelector((state) => state.collection);
  const CollectionTitle = useAdminHelperFunction("Collection_title");

  // const collectionObj = {
  //   label: "Sample",
  //   collectionDetails: collectedItems,
  // };
  const dispatch = useDispatch();

  const handleAddtoCollection = (label) => {
    const collectedItemDetail = {
      label: label,
      collectedItem,
    };
    dispatch(AddOrUpdateCollectionThunk(collectedItemDetail))
      .then(() => {
        dispatch(getAllCollectionsByAppUserIdlAndCompanyDivId());
        onClose();
      })
      .catch(() => {
        onClose();
      });
  };
  return (
    <>
      {/* {isOpen ? (
        <> */}
      {
        //  isAddAnotherCollection

        isOpen && (
          <div id="infoModal1" className="overlay">
            <div className="popup2">
              <div className="body">
                <div className="group">
                  <div className="span12">
                    <h4 className="float-left margin-bottom40">
                      Select a {CollectionTitle?.clientSpecificLabel || CollectionTitle?.defaultLabel}
                    </h4>
                    <div className="close-btn2 float-right">
                      <img
                        data-testid="close"
                        onClick={() => {
                          setIsAddAnotherCollection(false);
                          onClose();
                        }}
                        src={CloseImg}
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="clear"></div>
                  <div className="span12">
                    <div
                      className="overlay-content"
                      style={{ height: 300, overflowY: "scroll" }}
                    >
                      {collectionState?.AllCollectedItems.length ? collectionState?.AllCollectedItems?.map(
                        (collection, indx) => (
                          <div
                            key={indx}
                            onClick={() =>
                              handleAddtoCollection(collection?.label)
                            }
                          >
                            <div className="collection">
                              <span className="link">
                                <Link>{collection?.label}</Link>
                              </span>
                              <br />
                              {collection?.collectionDetailsCount} items
                            </div>
                          </div>
                        )
                      ) : <button
                      className="btn-primary  btn-margin"
                      onClick={() => navigate("/createcollection")}
                    >
                      CREATE {CollectionTitle?.clientSpecificLabel || CollectionTitle?.defaultLabel}
                    </button>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
        //     : (
        //       <div id="infoModal1" className="overlay">
        //         <div className="popup2">
        //           <div className="body">
        //             <div className="group">
        //               <div className="span12">
        //                 <h4 className="float-left margin-bottom40">Success!</h4>
        //                 <div className="close-btn2 float-right">
        //                   <img onClick={onClose} src={CloseImg} alt="" />
        //                 </div>
        //               </div>
        //               <div className="clear"></div>
        //               <div className="span12">
        //                 <div className="overlay-content">
        //                   <div className="collection">
        //                     This item has been added to:{" "}
        //                     <span className="link">FAVORITES</span>{" "}
        //                   </div>
        //                   <div
        //                     className="collection"
        //                     data-testid="addAnotherCollection"
        //                     onClick={onAddAnotherCollection}
        //                   >
        //                     <span className="link">
        //                       Add item to another collection
        //                     </span>
        //                   </div>
        //                 </div>
        //               </div>
        //             </div>
        //           </div>
        //         </div>
        //       </div>
        //     )}
        //   </>
        // ) : null}
      }
    </>
  );
}

export default ColletionsSuccessModal;
